import { render, staticRenderFns } from "./EmployeeFormSubmissionStatusDisplay.vue?vue&type=template&id=5d330974&"
import script from "./EmployeeFormSubmissionStatusDisplay.vue?vue&type=script&lang=ts&"
export * from "./EmployeeFormSubmissionStatusDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports